import React, { useEffect } from 'react';
import { Control } from 'react-hook-form';
import {
    Dialog,
    DialogTitle,
    Box,
    IconButton,
    Typography,
} from '@mui/material';
import { Close, CreditCard } from '@mui/icons-material';
import DigitalCardForm from './DigitalCardForm';
import { Branches } from './DigitalCard';

interface Props {
    isLoading: boolean;
    open: boolean;
    cardType: 'Green' | 'Silver' | 'Gold';
    control: Control;
    editCard: any;
    setValue: (name: string, value: any) => void;
    reset: (any: {}) => void;
    watch: (name: string) => any;
    setCardType: React.Dispatch<React.SetStateAction<'Green' | 'Silver' | 'Gold'>>;
    onClose: () => void;
    handleGenerateCard: (data: any) => void;
    branches: Branches[];
}

const DigitalCard: React.FC<Props> = ({
    isLoading, open, cardType, editCard, control, branches,
    reset, setValue, watch, setCardType, handleGenerateCard, onClose }) => {

    const cardNumberValue = watch('cardNumber');

    useEffect(() => {
        if (open && editCard && branches.length > 0) {
            const formattedBranches = branches.map((branch) => {
                const existingBranch = editCard.branches.find(
                    (b: { branchId: string}) => b.branchId === branch._id
                );

                return {
                    branchId: branch._id,
                    openingPoints: existingBranch?.points || 0,
                };
            });

            reset({
                cardNumber: editCard.cardNumber || '',
                customerName: editCard.customer.customerName || '',
                mobileNumber: editCard.customer.mobileNumber || '',
                emailAddress: editCard.customer.emailAddress || '',
                addressOne: editCard.customer.addressOne || '',
                addressTwo: editCard.customer.addressTwo || '',
                city: editCard.customer.city || '',
                state: editCard.customer.state || '',
                postalCode: editCard.customer.postalCode || '',
                anniversary: editCard.customer.anniversary || '',
                branches: formattedBranches,
            });

            setCardType(editCard.cardType);
        }
    }, [open, editCard, branches]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            keepMounted={false}
            fullWidth
            scroll='paper'
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
                    overflow: 'hidden'
                }
            }}
        >
            <DialogTitle sx={{
                m: 0,
                p: 3,
                background: 'linear-gradient(135deg, #273142 0%, #1a2436 100%)',
                color: 'white',
                position: 'relative',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <CreditCard sx={{ mr: 1.5, fontSize: 28 }} />
                    <Typography variant="h6" component="div" sx={{ fontWeight: 600, fontSize: '1.25rem' }}>
                        Issue New Card
                    </Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 16,
                        top: 16,
                        color: 'rgba(255,255,255,0.8)',
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        '&:hover': {
                            backgroundColor: 'rgba(255,255,255,0.2)',
                        }
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>

            <DigitalCardForm
                cardNumberValue={cardNumberValue} cardType={cardType} control={control} branches={branches}
                handleGenerateCard={handleGenerateCard} onClose={onClose} setCardType={setCardType}
                setValue={setValue} watch={watch}
                isLoading={isLoading} />

        </Dialog>
    );
};

export default DigitalCard;